<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-doctor-assist-delete"
      title="Delete User"
      ok-only
      ok-title="Delete"
      @ok="deleteItem"
    >
      <b-card-text>
        <h5>Are You Sure You Want to Remove This Doctor Assisatnt</h5>
        If you want to remove this Doctor Assisatnt, click the button below.
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-doctor-assist-edit"
      ok-only
      centered
      size="lg"
      :title="createMode ? 'Add Doctor Assisatnt' : 'Edit Doctor Assisatnt'"
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="12">
            <b-form-group label="Doctor Name" label-for="name">
              <b-form-input
                id="name"
                v-model="EditForm.name"
                placeholder="Docotr Assistant Name"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col lg="4">
            <b-form-group label="Price" label-for="Price">
              <b-form-input
                id="price"
                type="number"
                v-model="EditForm.price"
                placeholder="Price"
              />
            </b-form-group>
          </b-col> -->
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card>
      <!-- Search Patient Name -->
      <div>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t('surgery.Doctor Assist Info') }}</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-doctorAssist')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t('common.add') }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->

              <!-- Dropdown -->
              <ActionsButtons
                deletePerm="delete-doctorAssist"
                editPerm="update-doctorAssist"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
              <!-- <b-dropdown
                variant="link"
                toggle-class="p-0"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  v-if="
                    $store.state.app.permissions.includes('update-doctorAssist')
                  "
                  @click="show(data.item)"
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    $store.state.app.permissions.includes('delete-doctorAssist')
                  "
                  @click="deleteModel(data.item)"
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Delete</span>
                </b-dropdown-item>
              </b-dropdown> -->
            </div>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Assistants</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getDoctorAssistantsList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import Datepicker from 'vuejs-datepicker';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import ActionsButtons from '@/components/common/ActionsButtons.vue';

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    Datepicker,
    ActionsButtons,
  },

  props: ['patientCardId', 'doctorSurgeryId', 'doctorAssist', 'getData'],

  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      surgeryId: null,
      surgery: {},
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_surgery_id: '',
        name: '',
        price: '',
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        patient_card_surgery_id: '',
        name: '',
        price: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        {
          key: 'name',
          sortable: true,
        },

        { key: 'Actions' },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
    };
  },

  mounted() {
    // this.getDoctorAssistantsList();
    this.data = this.doctorAssist;
  },

  watch: {
    doctorAssist(newValue) {
      this.data = newValue;

      // this.EditForm.price = this.EditForm.price + this.doctorSurgery.price;
    },
  },
  methods: {
    show(item, mode) {
      if (mode === 'create') {
        this.surgeryId = null;
        this.createMode = true;
        this.EditForm = {
          patient_card_surgery_id: this.doctorSurgeryId,
          name: '',
          price: '',
          _method: 'POST',
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.patient_card_surgery_id = this.doctorSurgeryId;
        this.EditForm.name = item.name;
        this.EditForm.price = item.price;
        this.EditForm._method = 'PUT';
      }
      this.$bvModal.show('modal-doctor-assist-edit');
    },

    async getDoctorAssistantsList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `doctorAssist?page=${this.page}&take=${this.take}&sort=-id`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-doctor-assist-delete');
    },
    formatDate(date) {
      if (date) {
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `doctorAssist/${this.deleteForm.id}`)
        .then((response) => {
          // this.getDoctorAssistantsList();
          this.$emit('getData');
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.EditForm[item] == '' || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      this.EditForm.price = 0;
      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `doctorAssist`),
          this.$store
            .dispatch('create', this.params)
            .then((response) => {
              // this.getDoctorAssistantsList();
              // window.location.reload();

              this.$emit('getData');
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `doctorAssist/${this.EditForm.id}`),
          this.$store
            .dispatch('update', this.params)
            .then((response) => {
              // this.getDoctorAssistantsList();
              // window.location.reload();

              this.$emit('getData');
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
